import { i18n } from '../../shared/i18n'
import { logger } from '../logger'
import { readEnv } from '../runtime-env'

const GOOGLE_GIS_SCRIPT_URL = 'https://accounts.google.com/gsi/client'

let scriptLoaded = false

export function loadGoogleScript(): Promise<void> {
  if (scriptLoaded) {
    return Promise.resolve()
  }

  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${GOOGLE_GIS_SCRIPT_URL}"]`)) {
      scriptLoaded = true
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = GOOGLE_GIS_SCRIPT_URL
    script.async = true
    script.defer = true
    script.onload = () => {
      scriptLoaded = true
      resolve()
    }
    script.onerror = () => reject(new Error(i18n.t('common.errors.sdkLoadFailed')))
    document.head.appendChild(script)
  })
}

export function initializeGoogleAuth(onCredential: (credential: string) => void): void {
  const clientId = readEnv('VITE_GOOGLE_CLIENT_ID')

  if (!clientId) {
    throw new Error(i18n.t('common.errors.authConfigError'))
  }

  google.accounts.id.initialize({
    client_id: clientId,
    callback: (response) => {
      if (response.credential) {
        onCredential(response.credential)
      }
    },
    cancel_on_tap_outside: false,
  })
}

export function tryGoogleOneTap(): void {
  google.accounts.id.prompt((notification) => {
    if (notification.isNotDisplayed()) {
      logger.warn('[GoogleAuth] One Tap not displayed:', notification.getNotDisplayedReason())
    }
    if (notification.isSkippedMoment()) {
      logger.warn('[GoogleAuth] One Tap skipped:', notification.getSkippedReason())
    }
  })
}
